import { ReviewsWeeklyDigest } from '@app/model/review/digest/weekly/ReviewsWeeklyDigest';
import React from 'react';
import Utilities from '@util/Utilities';
import { ReviewsMonthlyDigest } from '@app/model/review/digest/montly/ReviewsMonthlyDigest';
import CompetitorReviewsState from '@app/model/review/state/CompetitorReviewsState';

const ReviewsPropertyInsightsCompetitiveAnalysis: React.FunctionComponent<{
	digest: ReviewsWeeklyDigest | ReviewsMonthlyDigest
}> = ({ digest }) => {

	const currentReviewsState = digest.current;
	const previousReviewsState = digest.previous;

	if (!currentReviewsState) {
		return null;
	}

	const hotelReviewStates = [...currentReviewsState.competitorReviewsStates]
		.sort((a, b) => (b.statistics.score ?? 0) - (a.statistics.score ?? 0));

	const findDiff = (currentHotelReviewsState: CompetitorReviewsState) => {
		const previousHotelReviewsState = previousReviewsState?.competitorReviewsStates.find(hotel => hotel.hotelId === currentHotelReviewsState.hotelId);
		if (!previousHotelReviewsState) return undefined;
		return Number(Math.round(currentHotelReviewsState.statistics.score * 10) / 10) - Number(Math.round(previousHotelReviewsState.statistics.score * 10) / 10);
	}

	return <div className="xl:col-span-12">
		<div className="px-3 mb-1"><h2 className="text-base font-semibold text-gray-900">Competitive Analysis</h2></div>
		<div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm px-4 py-3 sm:px-5 sm:py-4">
			<ul role="list" className="space-y-2">
				{hotelReviewStates.map((hotelReviewsState, index) => {
					const diff = findDiff(hotelReviewsState);

					return <li className={`rounded-md border border-gray-200 ${hotelReviewsState.isMainHotel ? "bg-blue-50" : "bg-white"} px-3 py-2.5`} key={hotelReviewsState.hotelId}>
						<div className="sm:flex flex-wrap items-start justify-between gap-x-3 space-y-3 sm:space-y-0">
							<div className="flex items-center gap-x-2">
								<div>
								<span
									className={`flex w-9 h-8 items-center justify-center rounded-full ${hotelReviewsState.isMainHotel ? "bg-blue-100" : "bg-gray-100"} font-semibold ${hotelReviewsState.isMainHotel ? "text-blue-700" : "text-gray-700"}`}>{index + 1}</span>
								</div>
								<div>
									<div className="text-sm font-medium text-gray-900">{hotelReviewsState.hotelName}</div>
									<div className="text-xs/3 text-gray-500">{hotelReviewsState.statistics.numberOfReviews} reviews</div>
								</div>
							</div>
							<div className="flex items-center gap-x-4">
									<div className="sm:text-right">
										<div
											className="text-sm font-bold text-gray-900">{Utilities.formatDouble(hotelReviewsState.statistics.score, 1, 'N/A', true)}
											{diff !== undefined && diff !== 0 && <span className={`ml-1 text-xs font-medium ${diff > 0 ? 'text-green-600' : 'text-red-600'}`}>({diff > 0 ? '+' : ''}{Utilities.formatDouble(diff, 1)})</span>}
											{(diff === undefined || diff === 0) && <span className="ml-1 text-xs font-medium text-gray-600">(+0.0)</span>}
										</div>
									<div className="text-xs text-gray-500">Score</div>
								</div>
								<div className="sm:text-right">
									<div
										className="text-sm font-bold text-gray-900">{Utilities.formatDouble(hotelReviewsState.statistics.responseRate * 100, 1)}%
									</div>
									<div className="text-xs text-gray-500">Response</div>
								</div>
							</div>
						</div>
					</li>;
				})}
			</ul>
		</div>
	</div>;
};

export default ReviewsPropertyInsightsCompetitiveAnalysis;
